import React from 'react';
import { LoadingSpinnerIcon } from '@/design-system/components/Icons';

const sizeMap = {
  sm: 'h-4 w-4',
  md: 'h-10 w-10',
  lg: 'h-20 w-20',
} as const;

interface SpinnerProps {
  size?: keyof typeof sizeMap;
  className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 'lg', className }) => {
  return (
    <LoadingSpinnerIcon
      className={`animate-spin ${sizeMap[size]}${className ? ` ${className}` : ''}`}
    />
  );
};
